/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_Prices_DescriptionInputs */

const id_reseller_pricing_prices_description = /** @type {(inputs: Reseller_Pricing_Prices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga jual Anda ke pelanggan dalam rupiah, tidak boleh di bawah harga modal yang Anda bayar ke KilatDomain. Kosongkan untuk tidak menjual.`)
};

const en_reseller_pricing_prices_description = /** @type {(inputs: Reseller_Pricing_Prices_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you charge your customers, in rupiah, never below the wholesale price you pay KilatDomain. Leave a price empty not to sell it.`)
};

/**
* | output |
* | --- |
* | "What you charge your customers, in rupiah, never below the wholesale price you pay KilatDomain. Leave a price empty not to sell it." |
*
* @param {Reseller_Pricing_Prices_DescriptionInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_prices_description = /** @type {((inputs?: Reseller_Pricing_Prices_DescriptionInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_Prices_DescriptionInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_prices_description(inputs)
	return id_reseller_pricing_prices_description(inputs)
});